import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { CreateNonJobEventComponent } from './create-non-job-event.component';



@NgModule({
  declarations: [
    CreateNonJobEventComponent
  ],
  exports: [
    CreateNonJobEventComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class CreateNonJobEventModule { }
